import { useState } from "react";
import { toast } from "sonner";
import { ArrowLeft, Check, Loader2, Sparkles, Zap } from "lucide-react";
import { errorText, vai } from "@/lib/vai";

// Offres de Vanta AI : Gratuit, Pro et Max (abonnement Stripe, par mois ou par an).

const ICONS = { free: Check, pro: Zap, max: Sparkles };

const euros = (n) => `${Number(n).toFixed(2).replace(/\.00$/, "").replace(".", ",")} €`;

export default function UpgradePage({ me, onBack }) {
  const [busy, setBusy] = useState("");
  const [yearly, setYearly] = useState(false);
  const subscribe = async (plan) => {
    setBusy(plan);
    try {
      const r = await vai.post("/subscribe", { plan, interval: yearly ? "year" : "month", origin_url: window.location.origin });
      window.location.assign(r.url);
    } catch (err) {
      toast.error(errorText(err, "Paiement indisponible"));
      setBusy("");
    }
  };
  const rank = { free: 0, pro: 1, max: 2 };
  return (
    <div className="flex-1 overflow-y-auto" data-testid="vai-upgrade">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        <button type="button" onClick={onBack} className="inline-flex items-center gap-1.5 text-sm text-white/50 hover:text-white mb-6"><ArrowLeft className="w-4 h-4" />Retour</button>
        <h1 className="text-3xl sm:text-4xl font-semibold tracking-tight text-center">Choisis ton offre Vanta AI</h1>
        <p className="text-center text-white/55 mt-3">Sans engagement : annulable à tout moment depuis les Réglages.</p>
        <div className="flex justify-center mt-6">
          <div className="relative inline-flex p-1 rounded-full border border-white/10 bg-white/[0.03]" role="radiogroup" aria-label="Durée de l'abonnement">
            <span className={`absolute top-1 bottom-1 w-[calc(50%-4px)] rounded-full bg-white transition-transform duration-300 ease-out ${yearly ? "translate-x-full" : ""}`} aria-hidden="true" />
            {[[false, "Par mois"], [true, "Par an"]].map(([value, label]) => (
              <button key={label} type="button" role="radio" aria-checked={yearly === value} onClick={() => setYearly(value)} data-testid={`vai-billing-${value ? "year" : "month"}`}
                className={`relative z-[1] w-32 py-1.5 rounded-full text-sm font-medium transition-colors ${yearly === value ? "text-black" : "text-white/65 hover:text-white"}`}>
                {label}{value && <span className={`ml-1.5 text-[10px] px-1.5 py-0.5 rounded-full ${yearly ? "bg-emerald-500/15 text-emerald-700" : "bg-emerald-500/15 text-emerald-300"}`}>-17 %</span>}
              </button>
            ))}
          </div>
        </div>
        <div className="grid md:grid-cols-3 gap-4 mt-10">
          {me.plans.map((p) => {
            const Icon = ICONS[p.id];
            const current = me.plan.id === p.id;
            const featured = p.id === "pro";
            return (
              <div key={p.id} className={`relative rounded-2xl border p-6 flex flex-col ${featured ? "border-blue-400/40 bg-gradient-to-b from-blue-500/[0.08] to-transparent" : "border-white/10 bg-white/[0.02]"}`} data-testid={`vai-plan-${p.id}`}>
                {featured && <span className="absolute -top-3 left-6 text-[11px] font-medium px-2 py-0.5 rounded-full bg-gradient-to-r from-blue-500 to-violet-600">Le plus choisi</span>}
                <div className="flex items-center gap-2"><Icon className="w-5 h-5 text-white/70" /><h2 className="text-lg font-semibold">{p.name}</h2></div>
                {yearly && p.price_year ? (
                  <div className="mt-4">
                    <p><span className="text-4xl font-semibold">{euros(p.price_year / 12)}</span><span className="text-white/45 text-sm"> / mois</span></p>
                    <p className="text-xs text-white/45 mt-1">{euros(p.price_year)} par an · <span className="line-through">{euros(p.price * 12)}</span> <span className="text-emerald-300">2 mois offerts</span></p>
                  </div>
                ) : (
                  <p className="mt-4"><span className="text-4xl font-semibold">{p.price ? euros(p.price) : "0 €"}</span><span className="text-white/45 text-sm"> / mois</span></p>
                )}
                <ul className="mt-6 space-y-2.5 text-sm text-white/75 flex-1">
                  {p.features.map((f) => <li key={f} className="flex items-start gap-2"><Check className="w-4 h-4 mt-0.5 text-sky-300 shrink-0" />{f}</li>)}
                </ul>
                {current ? (
                  <div className="mt-6 py-2.5 text-center text-sm rounded-xl border border-white/10 text-white/50">Ton offre actuelle</div>
                ) : rank[p.id] < rank[me.plan.id] || p.id === "free" ? (
                  <div className="mt-6 py-2.5 text-center text-sm text-white/35">—</div>
                ) : (
                  <button type="button" onClick={() => subscribe(p.id)} disabled={!!busy} data-testid={`vai-subscribe-${p.id}`}
                    className={`mt-6 py-2.5 rounded-xl text-sm font-medium flex items-center justify-center gap-2 ${featured ? "bg-gradient-to-r from-blue-500 to-violet-600 hover:brightness-110" : "bg-white text-black hover:bg-white/90"} disabled:opacity-60`}>
                    {busy === p.id && <Loader2 className="w-4 h-4 animate-spin" />}Passer à {p.name}{yearly ? " (annuel)" : ""}
                  </button>
                )}
              </div>
            );
          })}
        </div>
        <p className="text-center text-xs text-white/35 mt-8">Paiement sécurisé par Stripe. Les quotas se rechargent toutes les 5 heures et chaque semaine.</p>
      </div>
    </div>
  );
}
